/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ModulesTournamentsApplicationTournamentPlayersTournamentPlayerResponse { 
    tournamentId?: string;
    tournamentName?: string;
    tournamentNumber?: string;
    playerId?: string;
    playerFirstName?: string;
    playerLastName?: string;
    playerMiddleName?: string;
    playerShortName?: string;
    lpgaId?: number;
    lpgaAccountId?: number;
    wwgrId?: number;
    tourId?: string;
    tourName?: string;
    playerCity?: string;
    playerStateId?: number;
    playerStateName?: string;
    playerStateCode?: string;
    playerCountryId?: number;
    playerCountryName?: string;
    playerCountryCode?: string;
    categoryId?: number;
    categoryRank?: number;
    fieldRank?: number;
    abrank?: number;
    money?: number;
    hometown?: string;
    categoryName?: string;
    type?: string;
    r1Wave?: string;
    memberStatus?: string;
    isProfessional?: boolean;
    isAmateur?: boolean;
    isRookie?: boolean;
    isSymetraGrad?: boolean;
    isSponsorInvite?: boolean;
    isQualifier?: boolean;
    isTitleist?: boolean;
    isCmePointsEligible?: boolean;
    isClubPro?: boolean;
    readonly createdOnUtc?: Date;
    readonly modifiedOnUtc?: Date;
}